/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as QuerySuggestionsRouteImport } from './routes/query-suggestions'
import { Route as ProductsRouteImport } from './routes/products'
import { Route as CategoriesRouteImport } from './routes/categories'
import { Route as IndexRouteImport } from './routes/index'
import { Route as ProductsCategoryIdRouteImport } from './routes/products/$categoryId'
import { Route as CategoriesCategoryIdRouteImport } from './routes/categories/$categoryId'
import { Route as ProductsCategoryIdSubcategoryIdRouteImport } from './routes/products/$categoryId/$subcategoryId'
import { Route as CategoriesMappingsSubcategoryIdRouteImport } from './routes/categories/mappings/$subcategoryId'
import { Route as ProductsCategoryIdDetailsProductIdRouteImport } from './routes/products/$categoryId/details/$productId'

const QuerySuggestionsRoute = QuerySuggestionsRouteImport.update({
  id: '/query-suggestions',
  path: '/query-suggestions',
  getParentRoute: () => rootRouteImport,
} as any)
const ProductsRoute = ProductsRouteImport.update({
  id: '/products',
  path: '/products',
  getParentRoute: () => rootRouteImport,
} as any)
const CategoriesRoute = CategoriesRouteImport.update({
  id: '/categories',
  path: '/categories',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const ProductsCategoryIdRoute = ProductsCategoryIdRouteImport.update({
  id: '/$categoryId',
  path: '/$categoryId',
  getParentRoute: () => ProductsRoute,
} as any)
const CategoriesCategoryIdRoute = CategoriesCategoryIdRouteImport.update({
  id: '/$categoryId',
  path: '/$categoryId',
  getParentRoute: () => CategoriesRoute,
} as any)
const ProductsCategoryIdSubcategoryIdRoute =
  ProductsCategoryIdSubcategoryIdRouteImport.update({
    id: '/$subcategoryId',
    path: '/$subcategoryId',
    getParentRoute: () => ProductsCategoryIdRoute,
  } as any)
const CategoriesMappingsSubcategoryIdRoute =
  CategoriesMappingsSubcategoryIdRouteImport.update({
    id: '/mappings/$subcategoryId',
    path: '/mappings/$subcategoryId',
    getParentRoute: () => CategoriesRoute,
  } as any)
const ProductsCategoryIdDetailsProductIdRoute =
  ProductsCategoryIdDetailsProductIdRouteImport.update({
    id: '/details/$productId',
    path: '/details/$productId',
    getParentRoute: () => ProductsCategoryIdRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/categories': typeof CategoriesRouteWithChildren
  '/products': typeof ProductsRouteWithChildren
  '/query-suggestions': typeof QuerySuggestionsRoute
  '/categories/$categoryId': typeof CategoriesCategoryIdRoute
  '/products/$categoryId': typeof ProductsCategoryIdRouteWithChildren
  '/categories/mappings/$subcategoryId': typeof CategoriesMappingsSubcategoryIdRoute
  '/products/$categoryId/$subcategoryId': typeof ProductsCategoryIdSubcategoryIdRoute
  '/products/$categoryId/details/$productId': typeof ProductsCategoryIdDetailsProductIdRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/categories': typeof CategoriesRouteWithChildren
  '/products': typeof ProductsRouteWithChildren
  '/query-suggestions': typeof QuerySuggestionsRoute
  '/categories/$categoryId': typeof CategoriesCategoryIdRoute
  '/products/$categoryId': typeof ProductsCategoryIdRouteWithChildren
  '/categories/mappings/$subcategoryId': typeof CategoriesMappingsSubcategoryIdRoute
  '/products/$categoryId/$subcategoryId': typeof ProductsCategoryIdSubcategoryIdRoute
  '/products/$categoryId/details/$productId': typeof ProductsCategoryIdDetailsProductIdRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/categories': typeof CategoriesRouteWithChildren
  '/products': typeof ProductsRouteWithChildren
  '/query-suggestions': typeof QuerySuggestionsRoute
  '/categories/$categoryId': typeof CategoriesCategoryIdRoute
  '/products/$categoryId': typeof ProductsCategoryIdRouteWithChildren
  '/categories/mappings/$subcategoryId': typeof CategoriesMappingsSubcategoryIdRoute
  '/products/$categoryId/$subcategoryId': typeof ProductsCategoryIdSubcategoryIdRoute
  '/products/$categoryId/details/$productId': typeof ProductsCategoryIdDetailsProductIdRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/categories'
    | '/products'
    | '/query-suggestions'
    | '/categories/$categoryId'
    | '/products/$categoryId'
    | '/categories/mappings/$subcategoryId'
    | '/products/$categoryId/$subcategoryId'
    | '/products/$categoryId/details/$productId'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/categories'
    | '/products'
    | '/query-suggestions'
    | '/categories/$categoryId'
    | '/products/$categoryId'
    | '/categories/mappings/$subcategoryId'
    | '/products/$categoryId/$subcategoryId'
    | '/products/$categoryId/details/$productId'
  id:
    | '__root__'
    | '/'
    | '/categories'
    | '/products'
    | '/query-suggestions'
    | '/categories/$categoryId'
    | '/products/$categoryId'
    | '/categories/mappings/$subcategoryId'
    | '/products/$categoryId/$subcategoryId'
    | '/products/$categoryId/details/$productId'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  CategoriesRoute: typeof CategoriesRouteWithChildren
  ProductsRoute: typeof ProductsRouteWithChildren
  QuerySuggestionsRoute: typeof QuerySuggestionsRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/query-suggestions': {
      id: '/query-suggestions'
      path: '/query-suggestions'
      fullPath: '/query-suggestions'
      preLoaderRoute: typeof QuerySuggestionsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/products': {
      id: '/products'
      path: '/products'
      fullPath: '/products'
      preLoaderRoute: typeof ProductsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/categories': {
      id: '/categories'
      path: '/categories'
      fullPath: '/categories'
      preLoaderRoute: typeof CategoriesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/products/$categoryId': {
      id: '/products/$categoryId'
      path: '/$categoryId'
      fullPath: '/products/$categoryId'
      preLoaderRoute: typeof ProductsCategoryIdRouteImport
      parentRoute: typeof ProductsRoute
    }
    '/categories/$categoryId': {
      id: '/categories/$categoryId'
      path: '/$categoryId'
      fullPath: '/categories/$categoryId'
      preLoaderRoute: typeof CategoriesCategoryIdRouteImport
      parentRoute: typeof CategoriesRoute
    }
    '/products/$categoryId/$subcategoryId': {
      id: '/products/$categoryId/$subcategoryId'
      path: '/$subcategoryId'
      fullPath: '/products/$categoryId/$subcategoryId'
      preLoaderRoute: typeof ProductsCategoryIdSubcategoryIdRouteImport
      parentRoute: typeof ProductsCategoryIdRoute
    }
    '/categories/mappings/$subcategoryId': {
      id: '/categories/mappings/$subcategoryId'
      path: '/mappings/$subcategoryId'
      fullPath: '/categories/mappings/$subcategoryId'
      preLoaderRoute: typeof CategoriesMappingsSubcategoryIdRouteImport
      parentRoute: typeof CategoriesRoute
    }
    '/products/$categoryId/details/$productId': {
      id: '/products/$categoryId/details/$productId'
      path: '/details/$productId'
      fullPath: '/products/$categoryId/details/$productId'
      preLoaderRoute: typeof ProductsCategoryIdDetailsProductIdRouteImport
      parentRoute: typeof ProductsCategoryIdRoute
    }
  }
}

interface CategoriesRouteChildren {
  CategoriesCategoryIdRoute: typeof CategoriesCategoryIdRoute
  CategoriesMappingsSubcategoryIdRoute: typeof CategoriesMappingsSubcategoryIdRoute
}

const CategoriesRouteChildren: CategoriesRouteChildren = {
  CategoriesCategoryIdRoute: CategoriesCategoryIdRoute,
  CategoriesMappingsSubcategoryIdRoute: CategoriesMappingsSubcategoryIdRoute,
}

const CategoriesRouteWithChildren = CategoriesRoute._addFileChildren(
  CategoriesRouteChildren,
)

interface ProductsCategoryIdRouteChildren {
  ProductsCategoryIdSubcategoryIdRoute: typeof ProductsCategoryIdSubcategoryIdRoute
  ProductsCategoryIdDetailsProductIdRoute: typeof ProductsCategoryIdDetailsProductIdRoute
}

const ProductsCategoryIdRouteChildren: ProductsCategoryIdRouteChildren = {
  ProductsCategoryIdSubcategoryIdRoute: ProductsCategoryIdSubcategoryIdRoute,
  ProductsCategoryIdDetailsProductIdRoute:
    ProductsCategoryIdDetailsProductIdRoute,
}

const ProductsCategoryIdRouteWithChildren =
  ProductsCategoryIdRoute._addFileChildren(ProductsCategoryIdRouteChildren)

interface ProductsRouteChildren {
  ProductsCategoryIdRoute: typeof ProductsCategoryIdRouteWithChildren
}

const ProductsRouteChildren: ProductsRouteChildren = {
  ProductsCategoryIdRoute: ProductsCategoryIdRouteWithChildren,
}

const ProductsRouteWithChildren = ProductsRoute._addFileChildren(
  ProductsRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  CategoriesRoute: CategoriesRouteWithChildren,
  ProductsRoute: ProductsRouteWithChildren,
  QuerySuggestionsRoute: QuerySuggestionsRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
